/**
 * The all-zero GUID the .NET side reads as "no such id" (`Guid.Empty`).
 *
 * A device booking (PROD-2007) has NO provider. Endpoints whose request binds
 * a `Guid providerId` (e.g. `PreLoadAppointmentDetails`) reject `''` outright
 * but bind `Guid.Empty`, so device-booking callers send this and every
 * provider-only surface treats it as "absent" via `isEmptyGuid`.
 */
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export function isEmptyGuid(value: string | null | undefined): boolean {
  return !value || value === EMPTY_GUID;
}
